<!--
  - @copyright Copyright (c) 2021 Marco Ambrosini <marcoambrosini@icloud.com>
  -
  - @author Marco Ambrosini <marcoambrosini@icloud.com>
  -
  - @license GNU AGPL version 3 or any later version
  -
  - This program is free software: you can redistribute it and/or modify
  - it under the terms of the GNU Affero General Public License as
  - published by the Free Software Foundation, either version 3 of the
  - License, or (at your option) any later version.
  -
  - This program is distributed in the hope that it will be useful,
  - but WITHOUT ANY WARRANTY; without even the implied warranty of
  - MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  - GNU Affero General Public License for more details.
  -
  - You should have received a copy of the GNU Affero General Public License
  - along with this program. If not, see <http://www.gnu.org/licenses/>.
-->
<docs>
This component is made to be used inside of the [NcActions](#NcActions) component slots.

```vue
	<NcActions>
		<NcActionCaption title="Test caption" />
		<NcActionCaption title="Test caption 2" />
	</NcActions>
```
</docs>

<template>
	<li class="app-navigation-caption">
		{{ title }}
	</li>
</template>

<script>
export default {
	name: 'NcActionCaption',
	props: {
		/**
		 * The caption's text
		 */
		title: {
			type: String,
			required: true,
		},
	},
}
</script>

<style lang="scss" scoped>
	.app-navigation-caption {
		color: var(--color-text-maxcontrast);
		line-height: $clickable-area;
		white-space: nowrap;
		text-overflow: ellipsis;
		box-shadow: none !important;
		user-select: none;
		pointer-events: none;
		margin-left: 12px;
		padding-right: 14px;
		height: $clickable-area;
		display: flex;
		align-items: center;
	}
</style>
